import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export interface TrendingEtfSecurityClickedProps extends EventProps {
    security_code?: string
    security_name?: string
    change_in_price_ytd?: number
}

/**
 * @event trending_etf_security_clicked
 * @description Emitted when a trending ETF security card is clicked.
 */
export const TrendingEtfSecurityClickedAnalytics = createAnalyticsStatic<TrendingEtfSecurityClickedProps>(
    ANALYTICS_EVENTS.TRADING.TRENDING_ETF_SECURITY_CLICKED,
)

export default TrendingEtfSecurityClickedAnalytics
